<mat-card class="portal-page-heading mb-2">
  <mat-card-content>
    <div class="flex flex-row justify-start items-center gap-4">

      <mat-icon class="portal-heading-icon" aria-hidden="true" fontIcon="home_health"></mat-icon>
      <h1 class="portal-page-title">Manage In Home Care Claim Requests</h1>
    </div>
  </mat-card-content>
</mat-card>

<div class="flex flex-col gap-2">
  <div>
    <button mat-raised-button color="primary" (click)="getLicenseRequests(!showAll)">Show {{showAll? "Pending" : "All"}}</button>
  </div>

  <div class="flex flex-col md:flex-row md:gap-4 portal-section-grid">
    <div class="md:w-1/2" *ngIf="request.id == 0" [@slideRight]>
      <mat-table [dataSource]="requestSource" matSort #requestSort="matSort" aria-describedby="Claim Requests" class="mat-elevation-z8 portal-responsive-table">
        <ng-container matColumnDef="owner">
          <mat-header-cell *matHeaderCellDef mat-sort-header>Owner</mat-header-cell>
          <mat-cell tabindex="0" *matCellDef="let request">
            <span class="mobile-label">Owner</span>
            {{ request.owner }}
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="licenseNumber">
          <mat-header-cell *matHeaderCellDef mat-sort-header>License Number</mat-header-cell>
          <mat-cell tabindex="0" *matCellDef="let request">
            <span class="mobile-label">License</span>
            {{ request.licenseNumber }}
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="email">
          <mat-header-cell *matHeaderCellDef mat-sort-header>Email</mat-header-cell>
          <mat-cell tabindex="0" *matCellDef="let request">
            <span class="mobile-label">Email</span>
            <span class="break-after-20">{{ request.email }}</span>
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="status">
          <mat-header-cell *matHeaderCellDef mat-sort-header>Status</mat-header-cell>
          <mat-cell tabindex="0" *matCellDef="let request">
            <span class="mobile-label">Status</span>
            <span *ngIf="request.approved" class="text-green-500">Approved</span>
            <span *ngIf="request.denied" class="text-red-500">Denied</span>
            <span *ngIf="!request.approved && !request.denied" class="text-yellow-500">Pending</span>
          </mat-cell>
        </ng-container>

        <mat-header-row *matHeaderRowDef="requestColumns"></mat-header-row>
        <mat-row *matRowDef="let row; columns: requestColumns" class="" (click)="selectRequest(row)" tabindex="0" (keydown.enter)="$event.target === $event.currentTarget && (selectRequest(row))" (keydown.space)="$event.target === $event.currentTarget && $event.preventDefault(); $event.target === $event.currentTarget && (selectRequest(row))"></mat-row>
      </mat-table>
      <mat-paginator [pageSizeOptions]="[20, 50, 100]" #requestPaginator="matPaginator">
      </mat-paginator>
    </div>

    <div class="flex flex-col md:flex-row gap-4 w-full portal-section-grid" *ngIf="request.id > 0" [@slideRight]>
      <mat-card class="md:w-1/2">
        <mat-card-content>
          <div class="flex flex-col md:flex-row pb-4 portal-actions">
            <span class="text-xl font-bold">Manage Claim Request For License: {{request.licenseNumber}}</span>
            <button class="ml-auto" type="button" mat-button color="warn" (click)="close()">Close</button>
          </div>

          <div class="flex flex-col gap-2">
            <div class="flex flex-col md:flex-row md:gap-2 portal-detail-row">
              <span class="text-large font-semibold md:w-1/6">License:</span>
              <span>{{ requestStatus }}</span>
            </div>

            <div class="flex flex-col md:flex-row md:gap-2 portal-detail-row">
              <span class="text-large font-semibold md:w-1/6">Owner:</span>
              <span>{{ request.owner }}</span>
            </div>

            <div class="flex flex-col md:flex-row md:gap-2 portal-detail-row">
              <span class="text-large font-semibold md:w-1/6">Email:</span>
              <span>{{ request.email }}</span>
            </div>

            <div class="flex flex-col md:flex-row md:gap-2 portal-detail-row">
              <span class="text-large font-semibold md:w-1/6">Address:</span>
              <span>{{ claimAddress.street }},</span>
              <span>{{ claimAddress.city }},</span>
              <span>{{ claimAddress.state }}</span>
              <span>{{ claimAddress.zip }}</span>
            </div>

            <div class="flex flex-col md:flex-row md:gap-2 portal-detail-row" *ngIf="ownerChange && request.parentId">
              <span class="text-large font-semibold md:w-1/6">New Parent:</span>
              <span>{{ request.parentId }}</span>
            </div>

            <div *ngIf="!request.approved && !request.denied" class="flex flex-col gap-2 pt-4">
              <span class="text-large font-semibold">If denied provide the reason:</span>
              <mat-form-field appearance="fill" class="w-full">
                <mat-label>Reason</mat-label>
                <textarea matInput [(ngModel)]="reason"></textarea>
              </mat-form-field>
            </div>

            <div *ngIf="request.approved || request.denied" class="flex flex-col gap-2 pt-4">
              <div class="flex flex-col md:flex-row md:gap-2 portal-detail-row">
                <span class="text-large font-semibold md:w-1/6">Status:</span>
                <span [ngClass]="request.approved? 'text-green-500' : 'text-red-500'">{{ request.approved ? 'Approved' : 'Denied' }}</span>
              </div>
              <div class="flex flex-col md:flex-row md:gap-2 portal-detail-row" *ngIf="request.denied">
                <span class="text-large font-semibold md:w-1/6">Reason:</span>
                <span>{{ request.deniedReason }}</span>
              </div>
              <div class="flex flex-col md:flex-row md:gap-4 pt-4">
                <div class="flex flex-col md:flex-row md:gap-4 portal-detail-row">
                  <span class="text-large font-semibold">{{request.approved? 'Approved' : 'Denied'}} By:</span>
                  <span>{{ request.finalDeterminationBy }}</span>
                </div>
                <div class="flex flex-col md:flex-row md:gap-4 portal-detail-row">
                  <span class="text-large font-semibold">Date {{request.approved? 'Approved' : 'Denied'}}:</span>
                  <span>{{ request.finalDeterminationDate | date }}</span>
                </div>
              </div>
            </div>

            <div class="flex flex-row" *ngIf="!request.approved && !request.denied">
              <div class="ml-auto flex flex-row gap-4 portal-actions">
                <button mat-raised-button color="primary" (click)="approveRequest(true)">Approve</button>
                <button mat-raised-button color="warn" [disabled]="reason == ''" (click)="approveRequest(false)">Deny</button>
              </div>
            </div>

          </div>
        </mat-card-content>
      </mat-card>

      <mat-card *ngIf="ownerChange.id > 0" class="md:w-1/2">
        <mat-card-content>
          <span class="text-xl font-bold">Related Owner Change Request</span>

          <div class="flex flex-col gap-4">
            <mat-card>
              <mat-card-content>
                <entity-owner [entityId]="ownerChange.id"
                              [entityType]="sharedService.inHomeCareChange"
                              [isChange]="true">
                </entity-owner>
              </mat-card-content>
            </mat-card>

            <div class="flex flex-col md:flex-row portal-section-grid">
              <div class="flex flex-col md:w-1/3" *ngIf="ownerChange.subunits.length > 0">
                <span class="font-semibold text-lg">Subunits being transferred</span>
                <div *ngFor="let subunit of ownerChange.subunits">{{subunit}}</div>
              </div>
              <div class="flex flex-col md:w-1/3" *ngIf="ownerChange.newParent">
                <span class="font-semibold text-lg">New Parent</span>
                <span>{{ownerChange.newParent}}</span>
              </div>
              <div class="flex flex-col md:w-1/3">
                <span class="font-semibold text-lg">Status</span>
                <span>{{ownerChange.approved? 'Approved' : ownerChange.denied? 'Denied' : 'Pending'}}</span>
              </div>
            </div>
          </div>
        </mat-card-content>
      </mat-card>
    </div>
  </div>
</div>

